import { t } from "i18next";
import React from "react";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>{t("services")}</h2>
          <p>{t("services_text")}</p>
        </div>
        <div className="row service-items">
          <div className="col-md-4">
            <i class="fa-brands fa-gg-circle fa"></i>
            <div className="service-desc">
              <h3>{t("gpitco-plus")}</h3>
              <p>{t("gpitco-plus_text")}</p>
            </div>
          </div>
          <div className="col-md-4">
            <i class="fa-solid fa-square-root-variable fa"></i>
            <div className="service-desc">
              <h3>{t("serv-2")}</h3>
              <p>{t("serv-2_text")}</p>
            </div>
          </div>
          <div className="col-md-4">
            <i class="fa-solid fa-database fa"></i>
            <div className="service-desc">
              <h3>{t("serv-3")}</h3>
              <p>{t("serv-3_text")}</p>
            </div>
          </div>
          {/* <div className="col-md-4">
            <div className="service-icon">
              <img src="/img/invoice.png" alt="" />
            </div>
            <div className="service-desc">
              <h3>{t("serv-zatca")}</h3>
              <p>{t("serv-zatca_text")}</p>
            </div>
          </div> */}
          <div className="col-md-4">
            <i class="fa-solid fa-boxes-packing fa"></i>
            <div className="service-desc">
              <h3>{t("serv-4")}</h3>
              <p>{t("serv-4_text")}</p>
            </div>
          </div>
          <div className="col-md-4">
            <i class="fa-solid fa-money-bill-trend-up fa"></i>
            <div className="service-desc">
              <h3>{t("serv-5")}</h3>
              <p>{t("serv-5_text")}</p>
            </div>
          </div>
          <div className="col-md-4">
            <i class="fa-solid fa-building-columns fa"></i>
            <div className="service-desc">
              <h3>{t("serv-6")}</h3>
              <p>{t("serv-6_text")}</p>
            </div>
          </div>

          <div className="col-md-4">
            <i class="fa-solid fa-money-check-dollar fa"></i>
            <div className="service-desc">
              <h3>{t("serv-7")}</h3>
              <p>{t("serv-7_text")}</p>
            </div>
          </div>
          <div className="col-md-4">
            <i class="fa-solid fa-store fa"></i>
            <div className="service-desc">
              <h3>{t("serv-8")}</h3>
              <p>{t("serv-8_text")}</p>
            </div>
          </div>
          <div className="col-md-4">
            <i class="fa-solid fa-user-lock fa"></i>
            <div className="service-desc">
              <h3>{t("serv-9")}</h3>
              <p>{t("serv-9_text")}</p>
            </div>
          </div>
          <div className="col-md-4">
            <i class="fa-solid fa-cash-register fa"></i>
            <div className="service-desc">
              <h3>{t("serv-10")}</h3>
              <p>{t("serv-10_text")}</p>
            </div>
          </div>
          <div className="col-md-4">
            <i class="fa-solid fa-gears fa"></i>
            <div className="service-desc">
              <h3>{t("serv-11")}</h3>
              <p>{t("serv-11_text")}</p>
            </div>
          </div>
          <div className="col-md-4">
            <i class="fa-solid fa-barcode fa"></i>
            <div className="service-desc">
              <h3>{t("serv-12")}</h3>
              <p>{t("serv-12_text")}</p>
            </div>
          </div>
          {/* <div className="col-md-4">
            <i class="fa-brands fa-gg-circle fa"></i>
            <div className="service-desc">
              <h3>{t("serv-13")}</h3>
              <p>{t("serv-13_text")}</p>
            </div>
          </div> */}
          <div className="col-md-4">
            <i class="fa-solid fa-link fa"></i>
            <div className="service-desc">
              <h3>{t("serv-15")}</h3>
              <p>{t("serv-15_text")}</p>
            </div>
          </div>
          <div className="col-md-4">
            <i class="fa-solid fa-code fa"></i>
            <div className="service-desc">
              <h3>{t("serv-14")}</h3>
              <p>{t("serv-14_text")}</p>
            </div>
          </div>
          <div className="col-md-4">
            <i class="fa-solid fa-network-wired fa"></i>
            <div className="service-desc">
              <h3>{t("serv-16")}</h3>
              <p>{t("serv-16_text")}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// إمكانية ربط برنامج المطاعم مع المحاسبة والعكس

// توافق البرنامج مع جميع قطاعات التجزئة. توافق البرنامج مع برامج توصيل الطلبات
